module.exports = __webpack_public_path__ + "media/31.4c66bcdf.mp3";